import { render, staticRenderFns } from "./CreateNewAdmin.vue?vue&type=template&id=55d54f88&scoped=true&"
import script from "./CreateNewAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateNewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewAdmin.vue?vue&type=style&index=0&id=55d54f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d54f88",
  null
  
)

export default component.exports